<template>
    <v-layout row ma-0 class="align-center justify-space-between">
        <v-flex xs7 class="main-text mr-3">
            {{title}}
        </v-flex>
        <v-flex class="modal-row d-flex">
            <v-text-field
                v-model="time"
                :placeholder="placeholder"
                type="time"
                class="input-picker-grey time-field"
                dense
                hide-details
                :max="max"
            ></v-text-field>
        </v-flex>
    </v-layout>
</template>

<script>
export default {
    name: "time-field",
    props: {
        value: {
            type: String,
        },
        title: {
            type: String,
            default: "",
        },
        placeholder: {
            type: String,
            default: "Время",
        },
        min: {
            type: String,
            default: "",
        },
        max: {
            type: String,
            default: "",
        },
    },
    computed: {
        time: {
            get() {
                return this.value;
            },
            set(val) {
                this.$emit('input', this.setVal(val));
            }
        },
    },
    methods: {
        setVal(val) {
            let [hour, minute] = val.split(":");
            if (this.min) {
                let [min_hour, min_minute] = this.min.split(":");
                if (parseInt(hour) < parseInt(min_hour)) {
                    return `${String(min_hour).padStart(2, "0")}:${String(minute).padStart(2, "0")}`;
                }
                if (parseInt(hour) == parseInt(min_hour) && parseInt(minute) < parseInt(min_minute)) {
                    return `${String(hour).padStart(2, "0")}:${String(min_minute).padStart(2, "0")}`;
                }
            }
            if (this.max) {
                let [max_hour, max_minute] = this.max.split(":");
                if (parseInt(hour) > parseInt(max_hour)) {
                    return `${String(max_hour).padStart(2, "0")}:${String(minute).padStart(2, "0")}`;
                }
                if (parseInt(hour) == parseInt(max_hour) && parseInt(minute) > parseInt(max_minute)) {
                    return `${String(hour).padStart(2, "0")}:${String(max_minute).padStart(2, "0")}`;
                }
            }
            return val;
        },
    },
}
</script>

<style lang="scss">
.time-field {
    max-width: 100% !important;
    background: var(--rh-slider-background) !important;
}

.input-picker-grey.v-input.v-text-field {
    background: var(--rh-slider-background);
    border-radius: 30px;
    padding: 10px 24px;
    margin: 0;
    height: 39px;
    max-width: 140px;
    color: var(--rh-main-color);

    .v-input__slot {
        &::before, &::after, {
            content: none;
        }

        input {
            color: var(--rh-main-color);
            padding: 0;
            text-align: center;
        }
    }

    input::placeholder {
        font-weight: 400;
        font-size: 16px;
        line-height: 19px;
        color: var(--rh-main-color);
    }

    input[type="time"]::-webkit-calendar-picker-indicator {
        background: none;
        display: none;
    }
}
</style>